export function nanoIdLike() {
  return "el_" + Math.random().toString(36).slice(2, 10);
}

// Convert React-style props to SVG attribute names for serialization
const REACT_TO_SVG_ATTR = {
  strokeWidth: "stroke-width",
  strokeLinecap: "stroke-linecap",
  strokeLinejoin: "stroke-linejoin",
  strokeDasharray: "stroke-dasharray",
  strokeDashoffset: "stroke-dashoffset",
  fontSize: "font-size",
  fontFamily: "font-family",
  fontWeight: "font-weight",
};

export function attrToSvgName(k) {
  return REACT_TO_SVG_ATTR[k] || k;
}

export function clamp(v, min, max) {
  return Math.max(min, Math.min(max, v));
}
